export const DEFAULT_CURRENCY = 'USD';

export const CURRENCIES = {
  USD: '$',
  EUR: '€',
  CAD: 'C$',
  AUD: 'A$',
  PHP: '₱',
};
